import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withOverflowMenu } from '@jll/overflow-menu';
import styles from './avatar.scss';

const componentMainClass = 'avatar-group';

const OtherAvatarsTrigger = ({ title }) => (
    <button type="button" className={styles[`${componentMainClass}__others-text`]}>
        {title}
    </button>
);

OtherAvatarsTrigger.propTypes = {
    title: PropTypes.string
};

OtherAvatarsTrigger.defaultProps = {
    title: ''
};

class AvatarGroup extends Component {
    otherAvatarsList = (items, othersText) => {
        const triggerText = `+ ${items.length} ${items.length > 1 ? othersText.multiple : othersText.single}`;
        const options = {
            content: items,
            tag: 'div',
            className: styles[`${componentMainClass}__others-wrap`]
        };
        const OtherAvatars = withOverflowMenu(OtherAvatarsTrigger, options);

        return <OtherAvatars title={triggerText} />;
    };

    render() {
        const { size, className, children, itemsVisible, othersText, ...other } = this.props;

        const getStyles = classNames.bind(styles);
        const avatarGroupClass = getStyles(componentMainClass, className);
        const avatarListClass = styles[`${componentMainClass}__avatar-list`];

        let visibleItemsArr = [];
        let hiddenItemsArr = [];
        let allItemsArr = [];

        allItemsArr = React.Children.map(children, item =>
            React.cloneElement(item, {
                wrapperClassName: styles[`${componentMainClass}__item`],
                className: styles[`${componentMainClass}__item`],
                notifications: null,
                showName: false,
                size
            })
        );

        if (itemsVisible > 0 && itemsVisible <= allItemsArr.length) {
            visibleItemsArr = allItemsArr.slice(0, itemsVisible);
            hiddenItemsArr = allItemsArr.slice(itemsVisible, children.length);

            hiddenItemsArr = React.Children.map(hiddenItemsArr, item =>
                React.cloneElement(item, {
                    notifications: null,
                    showName: true,
                    size: 'small'
                })
            );
        } else {
            visibleItemsArr = allItemsArr;
        }

        return (
            <div className={avatarGroupClass} {...other}>
                <div className={avatarListClass}>{visibleItemsArr}</div>
                {hiddenItemsArr.length ? this.otherAvatarsList(hiddenItemsArr, othersText) : null}
            </div>
        );
    }
}

AvatarGroup.propTypes = {
    /** Class name of the avatar group wrapper */
    className: PropTypes.string,
    /** Avatar group items. */
    children: PropTypes.node,
    /** Number of visible avatar items. */
    itemsVisible: PropTypes.number,
    /** Text on the button, which opens overflow menu with the avatar's list items. */
    othersText: PropTypes.shape({
        multiple: PropTypes.string,
        single: PropTypes.string
    }),
    /** Size of the avatar */
    size: PropTypes.oneOf(['large', 'medium', 'small'])
};

AvatarGroup.defaultProps = {
    className: '',
    children: null,
    itemsVisible: '3',
    othersText: {
        single: 'other',
        multiple: 'others'
    },
    size: 'large'
};

export default AvatarGroup;
